export default __webpack_public_path__ + "static/media/gene-therapy.5da46f70.jpg";